import {Injectable} from '@angular/core';
import {AccessTokenPayload} from './access-token-payload';
import {Utils} from '@astek/utils';

@Injectable()
export class TokenStorageService {

  private static readonly ACCESS_TOKEN_STORAGE_KEY: string = 'accessToken';

  private _accessTokenPayload: AccessTokenPayload | null = null;
  private _preAccessToken: string | null = null;


  public setPreAccessToken(value: string): void {
    this._preAccessToken = value;
  }

  public getPreAccessToken(): string | null {
    return this._preAccessToken;
  }

  public readAccessTokenPayload(): AccessTokenPayload | null {
    return this._accessTokenPayload;
  }

  public extractPayload(jwt: string | null): AccessTokenPayload | null {
    if (Utils.isNullOrUndefined(jwt) || !jwt.match(/.*\..*\..*/)) {
      return null;
    }
    const payload: string = jwt.split('.')[1];
    const remainder: number = payload.length % 4;
    if (remainder) {
      payload.concat('='.repeat(4 - remainder));
    }
    payload.replace('-', '+').replace('_', '/');
    return JSON.parse(decodeURIComponent(encodeURIComponent(atob(payload)))) as AccessTokenPayload;
  }

  public isValidTokenPayload(token?: AccessTokenPayload | null): token is AccessTokenPayload {
    return Utils.isNotNullOrUndefined(token)
      && Utils.isNotNullOrUndefined(token.exp)
      && Utils.isNotNullOrUndefined(token.roles)
      && Utils.isNotNullOrUndefined(token.id)
      && Utils.isNotNullOrUndefined(token.email)
      && Utils.isNotNullOrUndefined(token.roles)
      && Utils.isNotNullOrUndefined(token.firstName)
      && Utils.isNotNullOrUndefined(token.lastName);
  }

  public computeRemainingValidity(token?: AccessTokenPayload | null): number {
    if (!this.isValidTokenPayload(token)) {
      return 0;
    }
    const expiresIn: number = token.exp - Math.round(Date.now() / 1000);
    return Math.max(expiresIn, 0);
  }

  public writeAccessTokenPayload(payload: AccessTokenPayload): void {
    this._accessTokenPayload = payload;
  }

  public readAccessToken(): string | null {
    return localStorage.getItem(TokenStorageService.ACCESS_TOKEN_STORAGE_KEY);
  }

  public writeAccessToken(token: string): void {
    return localStorage.setItem(TokenStorageService.ACCESS_TOKEN_STORAGE_KEY, token);
  }

  public deleteAccessToken(): void {
    localStorage.removeItem(TokenStorageService.ACCESS_TOKEN_STORAGE_KEY);
  }

  public deleteAccessTokenIfMatches(token: string): void {
    if (this.readAccessToken() === token) {
      this.deleteAccessToken();
    }
  }
}
